<template>
  <div class="isolate flex max-w-full">
    <svg
      class="shrink-0 text-[#96F5BD]"
      height="24"
      width="5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 0H3.2C2.1 0 1.5 0 1.1.2a2 2 0 0 0-.9.9C0 1.5 0 2 0 3.2v4.9l.2.2.6.2c1.7.3 3 1.8 3 3.5s-1.3 3.2-3 3.5l-.6.2-.2.2v4.9c0 1.1 0 1.7.2 2.1.2.4.5.7.9.9.4.2 1 .2 2.1.2H5V0Z"
        fill="currentColor"
      />
    </svg>
    <div
      class="bg-static-success-mid body-2-bold flex h-24 min-w-0 items-center text-static-success-hi"
    >
      <component :is="deal.icon" class="w-16 shrink-0" />
      <span class="inline-block px-4 -ml-2">
        {{ deal.label }}
      </span>
    </div>
    <svg
      class="shrink-0 text-[#96F5BD]"
      height="24"
      width="5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 0h1.8c1.1 0 1.7 0 2.1.2.4.2.7.5.9.9.2.4.2 1 .2 2.1v4.9l-.2.2-.6.2c-1.7.3-3 1.8-3 3.5s1.3 3.2 3 3.5l.6.2.2.2v4.9c0 1.1 0 1.7-.2 2.1a2 2 0 0 1-.9.9c-.4.2-1 .2-2.1.2H0V0Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconArrowDownRightInCircleFilled } from '@ds/icons/IconArrowDownRightInCircleFilled'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'

import translations from './DealTag.translations'

const i18n = useI18n()

const DEALS_TAGS = {
  flash_sales: {
    label: i18n(translations.flashSalesTag),
    icon: IconBoltFilled,
  },
  seller_flash_sales: {
    label: i18n(translations.sellerFlashSalesTag),
    icon: IconArrowDownRightInCircleFilled,
  },
}

const { type } = defineProps<{ type: keyof typeof DEALS_TAGS }>()

const deal = computed(() => DEALS_TAGS[type] ?? null)
</script>
